// eslint-disable-next-line no-restricted-imports -- re-exported from ui-core
import { cva as _cva } from 'class-variance-authority';
// eslint-disable-next-line no-restricted-imports -- re-exported from ui-core
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function cva(...inputs) {
    const getClassName = _cva(...inputs);
    return (...args) => {
        return twMerge(getClassName(...args));
    };
}
